import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { getProjectEditionDataQuery } from "@query";
import { PROJECT_TYPE } from "@utils";
import { home } from "@paths";
import { useStores } from "@hooks";
import { EstimateEditorStore, EstimateEditorStoreProvider, EstimateLoadingAlert } from "@tools";
import { PageCircularProgress } from "@components";
import { PdfEditorView } from "./PdfEditorView";

export const PdfEditor = () => {
  const navigate = useNavigate();
  const { stateStore } = useStores();
  const { estimateUuid } = useParams();

  const [searchParams, setSearchParams] = useSearchParams();
  const [store, setStore] = useState(null);
  const [hasError, setError] = useState(0);

  useEffect(() => {
    onLoad();
    return () => {
      stateStore.resetFilesUploadProgress();
    }
  }, []);

  const onLoad = async () => {
    try {
      const {
        logo,
        projectData,
      } = await getProjectEditionDataQuery(estimateUuid);
      
      if(searchParams.get("new"))
        setSearchParams(undefined, {replace: true});
      
      setStore(new EstimateEditorStore({
        logo,
        estimateData: projectData,
        estimateType: PROJECT_TYPE.MINI
      }));
    } catch(e) {
      if(e.status === 403)
        navigate(home, { replace: true });
      else
        setError(2);
    }
  };

  if (hasError) return <EstimateLoadingAlert structureError={hasError === 1} />;

  return !store ? (
    <PageCircularProgress />
  ) : (
    <EstimateEditorStoreProvider value={store}>
      <PdfEditorView />
    </EstimateEditorStoreProvider>
  );
};
